import React from 'react';
import { FiCreditCard, FiCalendar, FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const StepProcess = () => {
  return (
    <div className="grid md:grid-cols-2 gap-6 mb-12">
      <div className="bg-zinc-900/80 border border-zinc-800 p-8 rounded-3xl relative overflow-hidden group">
        <div className="absolute top-0 right-0 p-4 text-6xl opacity-5 group-hover:scale-110 transition-transform">
          <SafeIcon icon={FiCreditCard} />
        </div>
        <div className="w-12 h-12 bg-indigo-600 rounded-2xl flex items-center justify-center text-white mb-6 font-black">1</div>
        <h4 className="text-xl font-black text-white uppercase mb-2">Realiza tu Pago</h4>
        <p className="text-gray-400 text-sm">Usa tu tarjeta de débito/crédito o solicita datos bancarios vía WhatsApp.</p>
      </div>

      <div className="bg-zinc-900/80 border border-yellow-500/30 p-8 rounded-3xl relative overflow-hidden group">
        <div className="absolute top-0 right-0 p-4 text-6xl opacity-5 group-hover:scale-110 transition-transform text-yellow-500">
          <SafeIcon icon={FiCalendar} />
        </div>
        <div className="w-12 h-12 bg-yellow-500 rounded-2xl flex items-center justify-center text-black mb-6 font-black">2</div>
        <h4 className="text-xl font-black text-white uppercase mb-2">Agenda tus Clases</h4>
        <p className="text-gray-400 text-sm">Llena el formulario de abajo. Activaremos tu cuenta y enviaremos tu horario en minutos.</p>
      </div>
    </div>
  );
};

export default StepProcess;